import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import PrimarySelect from "../../../Inputs/PrimarySelect/PrimarySelect";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";

export default function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, Header },
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [value, setValue] = useState("");

  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach(row => {
      if (typeof row.values[id] == "boolean" && row.values[id]) {
        options.add("true");
      } else if (typeof row.values[id] == "boolean" && !row.values[id]) {
        options.add("false");
      } else {
        options.add(row.values[id]);
      }
    });
    const values = [...options.values()];

    if (values.length) {
      return values.sort();
    } else {
      return values;
    }
  }, [id, preFilteredRows]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if(filterValue) {
      setValue(filterValue);
    } else {
      setValue("");
    }
  }, [filterValue]);

  const open = Boolean(anchorEl);
  const pid = open ? "simple-popover" : undefined;

  return (
    <>
      <FilterButton 
        filterValue={filterValue}
        onClick={handleClick}
      />
      <Popover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        <div style={{ padding: "20px" }}>  
          <PrimarySelect 
            id={`select-column-filter-${Header}`}
            label={`Filter ${Header}`}
            value={value}
            onChange={val => {
              setFilter(val || undefined);
              handleClose();
            }}
            options={options}
            width="160px"
          />
        </div>
      </Popover>
    </>
  );
}

SelectColumnFilter.propTypes = {
  column: PropTypes.object.isRequired
};